<template>
  <div v-cloak id="test1" class="col s12">
    <div class="row">
      <div class="col s12 m3"></div>
      <div class="col s12 m6">
        <h2>Enterprise Projects</h2>
      </div>
      <div class="col s12 m3">
        <a
          href="https://www.neumont.edu/forindustry/enterprisepartnerships.html"
          target="_blank"
        >What is an Enterprise Project?</a>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col s12 m4" v-for="(proj, index) in Enterprises" :key="index">
          <div class="card">
            <div class="card-image waves-effect waves-block waves-light">
              <img class="activator" :src="proj.icon" />
            </div>
            <div class="card-content">
              <span class="card-title activator grey-text text-darken-4">
                {{proj.company}}
                <i class="material-icons right pulse">more_vert</i>
              </span>
              <p>
                <a class="red-text" :href="proj.URL">Website</a>
              </p>
            </div>
            <div class="card-reveal">
              <span class="card-title grey-text text-darken-4">
                {{proj.position}}
                <i class="material-icons right">close</i>
              </span>
              <p>{{proj.date}}</p>
              <p>{{proj.desc}}</p>
              <p>{{proj.tech}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-for="(proj, index) in Enterprises" :key="index">
          <div class="row">
            <div class="col s3">
              <img :src="proj.icon" class="company-logo" alt srcset />
            </div>
            <div class="col s3">
              <h5>Company:</h5>
              {{proj.company}}
            </div>
            <div class="col s3">
              <h5>Date:</h5>
              {{proj.date}}
            </div>
            <div class="col s3">
              <h5>Company Website:</h5>
              <a :href="proj.URL">
                <i class="material-icons">launch</i>
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <h5>Position:</h5>
              {{proj.position}}
            </div>
            <div class="col s12">
              <h5>Project Description:</h5>
              {{proj.desc}}
            </div>
            <div class="col s12">
              <h5>Tech:</h5>
              {{proj.tech}}
            </div>
          </div>
          <hr />
    </div>-->
  </div>
</template>

<script>

export default {
  name: "EnterpriseProjectsPage",
  data() {
    return {
      Enterprises: [
        {
          id: 1,
          company: "DealerTrack",
          position: "Developer - Extern",
          tech: "Selenium C#, GitHub, VS 2017",
          desc:
            "Building automated tests and configuring an automation framework" +
            "for auto dealership software. Worked on creating new automation processes and refactoring configurations to help with test efficiency.",
          date: "April 2019 - June 2019",
          URL: "https://us.dealertrack.com",
          icon: "/dt2.png",
          techIcons: ["/tech/csharp.png"]
        },
        {
          id: 2,
          company: "JourneyTeam",
          position: "Developer - Extern",
          tech: "TypeScript, Azure Repos, VS Code",
          desc:
            "Development testing and coordinating test cases for system functionality.",
          date: "June 2019 - August 2019",
          URL: "https://www.journeyteam.com",
          icon: "/jt.png",
          techIcons: ["/tech/ts.png"]
        },
        {
          id: 3,
          company: "Control4",
          position: "Developer - Extern",
          tech: "React, TypeScript, Bootstrap, Cypress.io, Jest, Jira",
          desc: "Creation of a centralized web page(s) for admin capabilities.",
          date: "October 2019 - December 2019",
          URL: "https://www.control4.com",
          icon: "/ls.png",
          techIcons: ["/tech/react.png","/tech/ts.png","/tech/cypress.png", "/tech/jest.png"]
        }
      ]
    };
  }
};
</script>

<style scoped>
.card-image {
  height: 250px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.card {
  height: 400px;
  border: 1px solid #000;
  border-radius: 20px;
}

</style>